<template>
  <div class="tableWithPerPageSelection" v-if="finChargement">
    <error-msg-component :messages="messages"
                          :error="error"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          @close="error = $event"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllLignesSelected.length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class='column is-narrow pdr-0'>
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.autoRecherche">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.COMMANDES.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <montant-total-par-etat :lignesCommande="lignesCommande">
    </montant-total-par-etat>
    <v-server-table
      v-if="startArrayRendering && mountedLoadingEnd"
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      class="overflow-x-auto">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="lignesCommande">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <qd-checkbox v-model="props.row.selected">
        </qd-checkbox>
      </div>
      <div slot="devisCommande.etatRenouvellement" slot-scope="props"
           class="columns">
        <b-icon v-if="props.row.devisCommande.etatRenouvellement"
                class="column is-narrow"
                icon="circle"
                size="is-small"
                :type="getColorRound(props.row.devisCommande.etatRenouvellement)"
        >
        </b-icon>
        <div class="column">
          <router-link-blank v-if="isRenouvelerOrTacite(props.row.devisCommande.etatRenouvellement)
          && props.row.devisCommande.historique[0]
          && props.row.devisCommande.historique[0].id !== props.row.devisCommandeId"
                             :to="{ name: 'c.bodac.commandes',
                             params: { id: getIdCommande(props.row.devisCommande) } }"
                             :message="$t(getEtat(props.row.devisCommande.etatRenouvellement))">
          </router-link-blank>
          <div v-else>
            {{$t(getEtat(props.row.devisCommande.etatRenouvellement))}}
          </div>
        </div>
      </div>
      <div slot="devisCommande.code" slot-scope="props">
        <router-link-blank :to="{ name: 'c.bodac.commandes',
                    params: { id: props.row.devisCommandeId }}"
                           :message="props.row.devisCommande.code"
        >
        </router-link-blank>
      </div>
      <div slot="devisCommande.montantHt" slot-scope="props"
           class="is-pulled-right">
        {{ props.row.devisCommande.montantHt | formatDevise }}
      </div>
      <div slot="totalHtAvecLigneRemise" slot-scope="props"
           class="is-pulled-right">
        {{ props.row.totalHtAvecLigneRemise | formatDevise }}
      </div>
      <div slot="quantite" slot-scope="props"
        class="is-pulled-right">
        {{ props.row.quantite }}
      </div>
      <div slot="devisCommande.etat" slot-scope="props">
        {{ $t(props.row.etatLibelle) }}
      </div>
      <div slot="payeur" slot-scope="props">
        <router-link-blank
          v-for="(payeur, index) in props.row.listePayeurs"
          :key="index"
          :to="{ name: 'c.bodac.clients/contacts-client',
          params: { id: payeur.tiersId }}"
          :message="payeur.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="annonceur" slot-scope="props">
        <router-link-blank
          v-for="(annonceur, index) in props.row.listeAnnonceurs"
          :key="index"
          :to="{ name: 'c.bodac.clients/contacts-client',
          params: { id: annonceur.tiersId }}"
          :message="annonceur.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="groupe" slot-scope="props">
        <router-link-blank v-if="props.row.groupeId"
          :to="{ name: 'c.bodac.clients/contacts-client', params: { id: props.row.groupeId }}"
          :message="props.row.groupe">
        </router-link-blank>
      </div>
      <div slot="enseigne" slot-scope="props">
        <router-link-blank v-if="props.row.enseigneId"
          :to="{ name: 'c.bodac.clients/contacts-client', params: { id: props.row.enseigneId }}"
          :message="props.row.enseigne">
        </router-link-blank>
      </div>
      <div slot="marques" slot-scope="props">
        {{ props.row.marques}}
      </div>
      <div slot="typeProduit" slot-scope="props">
        {{ $t(getLibelleCategorieProduit(props.row.typeProduit)) }}
      </div>
      <div slot="dateDebut" slot-scope="props">
        {{props.row.dateDebut | formatDate}}
      </div>
      <div slot="dateFin" slot-scope="props">
        {{props.row.dateFin | formatDate}}
      </div>
      <div slot="devisCommande.dateRenouvellement"
           slot-scope="props">
        {{ props.row.devisCommande.dateRenouvellement | formatDate }}
      </div>
      <div slot="devisCommande.datePreavis"
           slot-scope="props">
        {{ props.row.devisCommande.datePreavis | formatDate }}
      </div>
      <div slot="devisCommande.dateDemandeDeRenouvellement"
           slot-scope="props">
        {{ props.row.devisCommande.dateDemandeDeRenouvellement | formatDate }}
      </div>
      <div slot="soldeStock"
           slot-scope="props" class="is-pulled-right">
        <router-link-blank :to="{ name: 'c.bodac.clients/contacts-stock',
                    params: { id: getAnnonceurId(props.row.devisCommande.intervenants) }}"
                           :message="props.row.soldeAnnonceur.toString()">
        </router-link-blank>
      </div>
      <div slot="actions" class="has-text-centered" slot-scope="props">
        <b-dropdown position="is-bottom-left" aria-role="list" class="has-text-left">
          <a slot="trigger">
            <b-icon icon="dots-vertical" type="is-default"></b-icon>
          </a>
          <b-dropdown-item
            v-if="props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENATTENTE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS"
            @click="checkPermissions(constantes.COMMANDES.maj) ?
            changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_RENOUVELEE, true)
            : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('listeLignesCommandeARenouveler.actions.renouveler')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
          v-if="props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENATTENTE
                        || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS"
            @click="checkPermissions(constantes.COMMANDES.maj) ?
            changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_RENOUVELEE)
            : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.marquerRenouvele')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            @click="checkPermissions(constantes.COMMANDES.maj) ?
            changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_ENATTENTE, false)
            : showPopUp()"
            v-if="props.row.devisCommande.etatRenouvellement === constantes.ETAT_NONRENOUVELEE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_TACITE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_RENOUVELEE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS">
            <p class="is-default is-size-6">
              {{ $t('listeLignesCommandeARenouveler.actions.aRenouveler')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            @click="checkPermissions(constantes.COMMANDES.maj) ?
            changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_NONRENOUVELEE, false)
            : showPopUp()"
            v-if="props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENATTENTE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS">
            <p class="is-default is-size-6">
              {{ $t('listeLignesCommandeARenouveler.actions.pasRenouveler')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.devisCommande.reconductible
            && (props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENATTENTE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS)"
            @click="checkPermissions(constantes.COMMANDES.maj)
            ? changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_TACITE, true) : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('listeLignesCommandeARenouveler.actions.reconduireTacitement')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.devisCommande.reconductible
            && (props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENATTENTE
            || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS)"
            @click="checkPermissions(constantes.COMMANDES.maj) ?
            changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_TACITE, false)
            : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.marquerReconduitTacitement')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENCOURS
              || props.row.devisCommande.etatRenouvellement === constantes.ETAT_ENATTENTE"
            @click="checkPermissions(constantes.COMMANDES.maj) ?
            changeEtatCmd(props.row.devisCommandeId, constantes.ETAT_ENCOURS, false)
            : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('listeLignesCommandeARenouveler.actions.enCours')}}
            </p>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight"
                :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-lignes-commande-a-renouveler ref="filtreListeLigneCommandeARenouveler"
          :tiersInformation="tiersInformation"
          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
          @recherche="makeRechercheFilter()"/>
      </div>
    </transition>
    <b-modal v-model="openPopUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('listeLignesCommandeARenouveler.popUpPrevention.messHeader',
        { etat: cmdToEdit.tradEtat })"
        :mess-footer="$t('listeLignesCommandeARenouveler.popUpPrevention.messFooter')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="updateEtat"
        @no="openPopUpPrevention = false">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpMotifNonRenouvellement" has-modal-card class="modal">
      <pop-up-motif-non-renouvellement :commande-ids="commandeMotifNonRenouvellementIds"
                                       @recherche="recherche"
      ></pop-up-motif-non-renouvellement>
    </b-modal>
    <b-modal v-model="popUpErrorChangeEtat" width="500px">
      <pop-up-erreur :mess-header="messageHeader"
                     :mess-footer="messageFooter"
                     :messages="codeCmdNotChange">
      </pop-up-erreur>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatDateIso from '@/services/general/formatIsoDate';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import filtreListeLignesCommandeARenouveler
  from '@/components/bodac/lignesCommande/filtre/filtreListeLignesCommandeARenouveler';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { SET_CRITERE_A_RENOUVELER } from '@/store/modules/bodac/commandeParligneCommande-mutation-type';
import selecteurAction from '@/components/general/selecteurAction';
import * as devisConf from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import {
  ACTION_EN_COURS_RENOUVELLEMENT, ACTION_MARQUER_RENOUVELEE,
  ACTION_MARQUER_RECONDUIT_TACITEMENT, ACTION_MARQUER_NE_PAS_RENOUVELER,
} from '@/configuration/commande/commandeConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import {
  retourEnAttente,
  enCoursRenouvellement,
  renouvellementReconduction as renouvellementReconductionCmd,
} from '@/api/commande/index';
import * as renouvellementReconduction from '@/services/bodac/commande/renouvellementReconduction/renouvellementReconduction';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import PopUpMotifNonRenouvellement from '@/components/commande/renouvellement/popUpMotifNonRenouvellement';
import popUpErreur from '@/components/general/popUpErreur';
import montantTotalParEtat from '@/components/bodac/lignesCommande/renouvellement/montantTotalParEtat';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationLignesCommande from '@/services/dcf/validation/validationVentePartielle';
import translate from '@/services/devisCommandes/validation/champsCommandeTranslator';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { REFERENCE_TABLE_LIGNES_COMMANDES_A_RENOUVELER } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import MixinParametreInterne from '@/mixins/parametreInterne';
import { columnsSplice } from '@/services/general/columns';
import * as clientConf from '@/configuration/tiers/tiersConf';

const Societe = createNamespacedHelpers('societe');
const LignesCommande = createNamespacedHelpers('commandeParLigneCommande');
const Permissions = createNamespacedHelpers('permissions');
const User = createNamespacedHelpers('user');

export default {
  mixins: [MixinParametreInterne],
  props: {
    tiersInformation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      showFiltre: false,
      constantes: {
        COMMANDES,
        ETAT_ENCOURS: devisConf.ETAT_ENCOURS,
        ETAT_ENATTENTE: devisConf.ETAT_ENATTENTE,
        ETAT_NONRENOUVELEE: devisConf.ETAT_NONRENOUVELEE,
        ETAT_RENOUVELEE: devisConf.ETAT_RENOUVELEE,
        ETAT_TACITE: devisConf.ETAT_TACITE,
        TYPOLOGIE_POINT_DE_VENTE: clientConf.TYPOLOGIE_POINT_DE_VENTE,
        TYPOLOGIE_ENSEIGNE: clientConf.TYPOLOGIE_ENSEIGNE,
        TYPOLOGIE_GROUPE: clientConf.TYPOLOGIE_GROUPE,
        TYPOLOGIE_AUCUN: clientConf.TYPOLOGIE_AUCUN,
      },
      openPopUpPrevention: false,
      popUpMotifNonRenouvellement: false,
      commandeMotifNonRenouvellementIds: [],
      codeCmdNotChange: [],
      cmdToEdit: {
        etat: null,
        tradEtat: null,
        id: '',
        action: false,
      },
      actions: [
        { action: ACTION_EN_COURS_RENOUVELLEMENT, translation: 'renouvellementCommande.actions.marquerEnCoursRenouvellement' },
        { action: ACTION_MARQUER_RENOUVELEE, translation: 'renouvellementCommande.actions.marquerRenouvele' },
        { action: ACTION_MARQUER_RECONDUIT_TACITEMENT, translation: 'renouvellementCommande.actions.marquerReconduitTacitement' },
        { action: ACTION_MARQUER_NE_PAS_RENOUVELER, translation: 'renouvellementCommande.actions.marquerPasRenouveler' },
      ],
      finChargement: false,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      popUpErrorChangeEtat: false,
      messageHeader: null,
      messageFooter: null,
      referenceTable: REFERENCE_TABLE_LIGNES_COMMANDES_A_RENOUVELER,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      mountedLoadingEnd: false,
    };
  },
  components: {
    TableItemsInView,
    filtreListeLignesCommandeARenouveler,
    routerLinkBlank,
    selecteurAction,
    popUpPrevention,
    PopUpMotifNonRenouvellement,
    popUpErreur,
    montantTotalParEtat,
    errorMsgComponent,
    parametrageTable,
    tableFooterTotaux,
    exportExcelButton,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...LignesCommande.mapGetters({
      lignesCommande: 'lignesARenouveler',
      total: 'totalCountARenouveler',
      criteresRecherche: 'criteresRechercheARenouveler',
      lastPayload: 'lastPayloadARenouveler',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    nombreCritere() {
      const banCritere = ['auto', 'dates', 'sens', 'etat', 'optionDate', 'produitRenouvelable'];
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      nbCritere += this.criteresRecherche.produitRenouvelable === null ? 0 : 1;
      if (this.criteresRecherche.dates) {
        nbCritere += this.criteresRecherche.dates.dateDebut ? 1 : 0;
      }
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    targetTotal() {
      return ['totalHtAvecLigneRemise'];
    },
    columns() {
      const columns = ['selected', 'devisCommande.etatRenouvellement', 'devisCommande.code', 'devisCommande.codeDossier',
        'libelle', 'nomCommercial', 'payeur', 'annonceur', 'groupe', 'enseigne', 'marques', 'dateDebut', 'dateFin', 'quantite',
        'totalHtAvecLigneRemise', 'devisCommande.montantHt', 'devisCommande.dateRenouvellement',
        'devisCommande.datePreavis', 'devisCommande.dateDemandeDeRenouvellement',
        'devisCommande.motifNonRenouvellement', 'typeProduit', 'soldeStock', 'actions'];
      if (this.ligneCommandeARenouvelerSpe) {
        columnsSplice(columns, 'dateDebut');
        columnsSplice(columns, 'dateFin');
        columnsSplice(columns, 'devisCommande.montantHt');
        columnsSplice(columns, 'typeProduit');
        columnsSplice(columns, 'payeur');
      } else {
        columnsSplice(columns, 'groupe');
        columnsSplice(columns, 'enseigne');
        columnsSplice(columns, 'marques');
        columnsSplice(columns, 'quantite');
        columnsSplice(columns, 'soldeStock');
      }
      return columns;
    },
    getAllLignesSelected() {
      return this.lignesCommande.filter((type) => { return type.selected; });
    },
    allLigneCommandeSelected() {
      return this.getAllLignesSelected.length === this.lignesCommande.length;
    },
    iconSelectTotal() {
      if (this.allLigneCommandeSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          'devisCommande.etatRenouvellement': this.$i18n.t('listeLignesCommandeARenouveler.tabs.etat'),
          'devisCommande.code': this.$i18n.t('listeLignesCommandeARenouveler.tabs.code'),
          'devisCommande.codeDossier': this.$i18n.t('listeLignesCommandeARenouveler.tabs.codeDossier'),
          nomCommercial: this.$i18n.t('listeLignesCommandeARenouveler.tabs.commercial'),
          payeur: this.$i18n.t('listeLignesCommandeARenouveler.tabs.payeur'),
          annonceur: this.$i18n.t('listeLignesCommandeARenouveler.tabs.annonceur'),
          'devisCommande.montantHt': this.$i18n.t('listeLignesCommandeARenouveler.tabs.montantHt'),
          totalHtAvecLigneRemise: this.$i18n.t('listeLignesCommandeARenouveler.tabs.totalHt'),
          dateDebut: this.$i18n.t('listeLignesCommandeARenouveler.tabs.dateDebut'),
          dateFin: this.$i18n.t('listeLignesCommandeARenouveler.tabs.dateFin'),
          libelle: this.$i18n.t('listeLignesCommandeARenouveler.tabs.produit'),
          typeProduit: this.$i18n.t('listeLignesCommandeARenouveler.tabs.typeProduit'),
          'devisCommande.dateRenouvellement': this.$i18n.t('listeLignesCommandeARenouveler.tabs.dateRenouvellement'),
          'devisCommande.datePreavis': this.$i18n.t('listeLignesCommandeARenouveler.tabs.datePreavis'),
          'devisCommande.dateDemandeDeRenouvellement': this.$i18n.t('listeLignesCommandeARenouveler.tabs.dateDemande'),
          'devisCommande.motifNonRenouvellement': this.$i18n.t('listeLignesCommandeARenouveler.tabs.motif'),
          groupe: this.$i18n.t('listeLignesCommandeARenouveler.tabs.groupe'),
          enseigne: this.$i18n.t('listeLignesCommandeARenouveler.tabs.enseigne'),
          marques: this.$i18n.t('listeLignesCommandeARenouveler.tabs.marques'),
          quantite: this.$i18n.t('listeLignesCommandeARenouveler.tabs.quantite'),
          soldeStock: this.$i18n.t('listeLignesCommandeARenouveler.tabs.soldeStock'),
          actions: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['devisCommande.etatRenouvellement', 'devisCommande.code', 'devisCommande.codeDossier', 'libelle', 'totalHtAvecLigneRemise', 'devisCommande.montantHt', 'devisCommande.dateRenouvellement', 'devisCommande.datePreavis', 'devisCommande.dateDemandeDeRenouvellement', 'devisCommande.motifNonRenouvellement', 'typeProduit'],
        columnsClasses: {
          annonceurs: 'ellipsis colonneListeIntervenants',
          payeurs: 'ellipsis colonneListeIntervenants',
          actions: 'colonneSelected',
          selected: 'colonneSelected',
        },
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          if (this.criteresRecherche.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          this.gestionDataLoadLignesCommande(data);
          return this.actionsLoadLignesCommandes(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.lignesCommande,
            count: this.total,
          };
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: devisConf.EXPORT_EXCEL_LIGNE_COMMANDE_A_RENOUVELER,
        typeExport: null,
        filtres: this.lastPayload,
      };
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...LignesCommande.mapActions({
      actionsLoadLignesCommandes: 'loadLigneCommandeARenouveler',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...LignesCommande.mapMutations({
      setCritereRecherche: SET_CRITERE_A_RENOUVELER,
    }),
    getIdCommande(actualCommande) {
      const index = actualCommande.historique.findIndex((historique) => {
        return historique.id === actualCommande.id;
      });
      return actualCommande.historique.length > 0 ? actualCommande.historique[index - 1].id : '';
    },
    getAnnonceurId(intervenants) {
      return (intervenants.find(intervenant => intervenant.annonceur)).tiersId;
    },
    async changeEtatEnAttente(id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await retourEnAttente(id);
        loadingComponent.close();
        messageSucces(this.$t('listeLignesCommandeARenouveler.messages.success.changeEtat'));
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    async enCoursRenouvellement(ids) {
      const loadingComponent = this.$buefy.loading.open();
      const params = {
        devisCommandeIds: ids,
      };
      try {
        await enCoursRenouvellement(params);
        loadingComponent.close();
        messageSucces(ids.length > 1
          ? this.$i18n.t('listeLignesCommandeARenouveler.messages'
            + '.success.changeEtatEnCoursMultiCommande')
          : this.$i18n.t('listeLignesCommandeARenouveler.messages.success.changeEtatEnCours'));
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    checkCommandeToEnCours() {
      if (this.getAllLignesSelected.every((ligne) => {
        return ligne.devisCommande.etatRenouvellement === devisConf.ETAT_ENCOURS
          || ligne.devisCommande.etatRenouvellement === devisConf.ETAT_ENATTENTE;
      })) {
        this.enCoursRenouvellement([...new Set(this.getAllLignesSelected.map(ligne => {
          return ligne.devisCommandeId;
        }))]);
        return;
      }
      this.codeCmdNotChange = [...new Set(this.getAllLignesSelected
        .filter(ligne => {
          return ligne.devisCommande.etatRenouvellement !== devisConf.ETAT_ENCOURS
            && ligne.devisCommande.etatRenouvellement !== devisConf.ETAT_ENATTENTE;
        })
        .map(ligne => { return { libelle: ligne.devisCommande.code }; }))];
      this.popUpErrorChangeEtat = true;
      this.messageHeader = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatEnCours');
      this.messageFooter = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatEnCoursDes');
    },
    async checkCommandeToMarquerRenouveleReconduit(etatRenouvellement) {
      const commandes = [...new Set(this.getAllLignesSelected.map(ligne => ligne.devisCommande))];
      const retour = await renouvellementReconduction.marquerListeCommandeRenouveleeReconduite(
        commandes, etatRenouvellement,
      );
      this.codeCmdNotChange = retour.codeCmdNotChange;
      this.popUpErrorChangeEtat = retour.popUpErrorChangeEtat;
      this.messageHeader = retour.messageHeader;
      this.messageFooter = retour.messageFooter;
      if (retour.success) this.recherche();
    },
    ajoutCommentaireNonRenouvellement(commandeIds) {
      this.popUpMotifNonRenouvellement = true;
      this.commandeMotifNonRenouvellementIds = commandeIds;
    },
    async updateEtat() {
      switch (this.cmdToEdit.etat) {
        case devisConf.ETAT_RENOUVELEE:
        case devisConf.ETAT_TACITE:
          if (this.cmdToEdit.action) {
            await this.renouveler(this.cmdToEdit);
          } else {
            await this.marquerRenouveleReconduit([this.cmdToEdit.id], this.cmdToEdit.etat);
          }
          break;
        case devisConf.ETAT_ENCOURS:
          this.enCoursRenouvellement([this.cmdToEdit.id]);
          break;
        case devisConf.ETAT_ENATTENTE:
          this.changeEtatEnAttente(this.cmdToEdit.id);
          break;
        default:
          this.ajoutCommentaireNonRenouvellement([this.cmdToEdit.id]);
          break;
      }
      this.openPopUpPrevention = false;
    },
    changeEtatCmd(id, etat, seulementModifierEtat) {
      this.cmdToEdit = {
        id: id,
        etat: etat,
        tradEtat: this.$i18n.t(this.getEtat(etat)),
        action: seulementModifierEtat,
      };
      this.openPopUpPrevention = true;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_EN_COURS_RENOUVELLEMENT:
          this.checkCommandeToEnCours();
          break;
        case ACTION_MARQUER_RENOUVELEE:
          this.checkCommandeToMarquerRenouveleReconduit(devisConf.ETAT_RENOUVELEE);
          break;
        case ACTION_MARQUER_RECONDUIT_TACITEMENT:
          this.checkCommandeToMarquerRenouveleReconduit(devisConf.ETAT_TACITE);
          break;
        case ACTION_MARQUER_NE_PAS_RENOUVELER:
          this.ouvrirPopUpMotifNePasRenouveler();
          break;
        default:
          throw new Error();
      }
    },
    selectAll() {
      const select = !this.allCommandeSelected;
      this.lignesCommande.forEach((el) => { el.selected = select; });
    },
    getColorRound(etatRenouvellement) {
      switch (etatRenouvellement) {
        case devisConf.ETAT_ENATTENTE:
          return 'is-aRenouveler';
        case devisConf.ETAT_TACITE:
          return 'is-tacite';
        case devisConf.ETAT_NONRENOUVELEE:
          return 'is-nonRenouvelee';
        case devisConf.ETAT_ENCOURS:
          return 'is-enCours';
        default:
          return 'is-primary';
      }
    },
    async marquerRenouveleReconduit(ids, etatRenouvellement) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const message = await renouvellementReconduction
          .marquerCommandeRenouveleeReconduite(ids, etatRenouvellement);
        loadingComponent.close();
        messageSucces(message);
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getEtat(etatCommande) {
      const etatRenouvellementFind = devisConf.LISTE_ETAT_RENOUVELLEMENT
        .find((etatRenouvellement) => {
          return etatRenouvellement.code === etatCommande;
        });
      return etatRenouvellementFind ? etatRenouvellementFind.libelle : '';
    },
    isRenouvelerOrTacite(etat) {
      return (etat === devisConf.ETAT_RENOUVELEE || etat === devisConf.ETAT_TACITE);
    },
    getLibelleCategorieProduit(typeProduit) {
      const typeProduitFind = CATEGORIE_PRODUIT.find((type) => {
        return type.code === typeProduit;
      });
      return typeProduitFind ? typeProduitFind.libelle : null;
    },
    gestionDataLoadLignesCommande(data) {
      if (data.query.dates) {
        data.query.dates.dateDebut = formatDateIso(data.query.dates.dateDebut);
        data.query.dates.dateFin = formatDateIso(data.query.dates.dateFin);
      }
      data.query.typesProduits = tagInputToArray(this.criteresRecherche.typesProduits, 'code');
      if (data.query.groupeIds.length > 0) {
        data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
      }
      if (data.query.enseigneIds.length > 0) {
        data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => { return enseigne.id; });
      }
      if (data.query.fournisseursId.length > 0) {
        data.query.fournisseursId = data.query.fournisseursId.map((fournisseur) => {
          return fournisseur.id;
        });
      }
      if (data.query.payeurs.length > 0) {
        data.query.payeurs = data.query.payeurs.map((payeur) => payeur.id);
      }
      if (data.query.annonceurs.length > 0) {
        data.query.annonceurs = data.query.annonceurs.map((annonceur) => annonceur.id);
      }
      data.query.societeId = this.societeActiveId;
      data.query.typesDevisCommandeFacture = [devisConf.TYPE_COMMANDE];
      data.query.renouvelable = true;
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeLigneCommandeARenouveler.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesId.length === 0) return;
      const agencesId = [];
      this.criteresRecherche.agencesId.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesId.push(id);
      });
      this.criteresRecherche.agencesId = agencesId;
      this.$refs[this.referenceTable].setPage(1);
    },
    async renouveler(commande) {
      if (commande === undefined || commande === null) return;
      this.error = false;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.openPopUpPrevention = false;
        await renouvellementReconductionCmd(this.cmdToEdit.id, this.cmdToEdit.etat);
        loadingComponent.close();
        this.$router.push({
          name: 'm.bodac.commandes-ajoutRenouvelOrTacite',
          params: { id: this.cmdToEdit.id, renouveleOrTacite: this.cmdToEdit.etat },
        });
      } catch (e) {
        loadingComponent.close();
        this.error = true;
        validationDevisCommande(e.response,
          this.messages,
          this.isNewDevisCommande,
          devisConf.TYPE_COMMANDE);
        await validationLignesCommande(e.response, this.messages, this.nouveauDevisCommande);
        validationGeneral(this.$i18n, e.response, this.champsVide,
          this.messages, this.messagesChampsVide, translate);
        throw e;
      }
    },
    async reinitialiser() {
      await this.$refs.filtreListeLigneCommandeARenouveler.initializeFiltre();
      await this.$refs.filtreListeLigneCommandeARenouveler.viderCritere();
      this.$refs.filtreListeLigneCommandeARenouveler.appliquerCritere();
      this.showFiltre = false;
    },
    ouvrirPopUpMotifNePasRenouveler() {
      if (this.getAllLignesSelected.every((ligne) => {
        return ligne.devisCommande.etatRenouvellement === devisConf.ETAT_ENCOURS
          || ligne.devisCommande.etatRenouvellement === devisConf.ETAT_ENATTENTE;
      })) {
        this.ajoutCommentaireNonRenouvellement(
          [...new Set(this.getAllLignesSelected.map(ligne => {
            return ligne.devisCommandeId;
          }))],
        );
        return;
      }
      this.codeCmdNotChange = [...new Set(this.getAllLignesSelected
        .filter(ligne => {
          return ligne.devisCommande.etatRenouvellement !== devisConf.ETAT_ENCOURS
            && ligne.devisCommande.etatRenouvellement !== devisConf.ETAT_ENATTENTE;
        })
        .map(ligne => { return { libelle: ligne.devisCommande.code }; }))];
      this.popUpErrorChangeEtat = true;
      this.messageHeader = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatNePasRenouveler');
      this.messageFooter = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatNePasRenouvelerDes');
    },
    async setupCritere() {
      const critere = cloneDeep(this.criteresRecherche);
      await updateCritereWithParametreInterne(critere);
      if (this.ligneCommandeARenouvelerSpe && this.tiersInformation) {
        switch (this.tiersInformation.typologie) {
          case this.constantes.TYPOLOGIE_AUCUN:
          case this.constantes.TYPOLOGIE_POINT_DE_VENTE:
            critere.annonceurs = [this.tiersInformation];
            break;
          case this.constantes.TYPOLOGIE_ENSEIGNE:
            critere.enseigneIds = [this.tiersInformation];
            break;
          case this.constantes.TYPOLOGIE_GROUPE:
            critere.groupeIds = [this.tiersInformation];
            break;
          default:
            break;
        }
      }
      this.setCritereRecherche(critere);
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.goFirstPageAndCheckChangement, this.recherche);
      await this.setupCritere();
      if (this.user.agences.length > 1) {
        this.criteresRecherche.agencesId = this.agencesSelectionnees
          .map((agence) => agence.agenceId);
      }
      this.finChargement = true;
      this.mountedLoadingEnd = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
